module.exports = __webpack_public_path__ + "static/b1-anchors3-4005a97b4d24ec3b6c4a4b3d94af30cb.jpg";